<template>
  <div class="AlignButtons">
    <UiIcon
      :title="$t('AlignButtons.AlignLeft')"
      @click="currentValue = 'left'"
      class="ToolbarButton"
      :class="{ 'is-active': currentValue == 'left' }"
      value="mdi:format-align-left"
    />

    <UiIcon
      :title="$t('AlignButtons.AlignCenter')"
      @click="currentValue = 'center'"
      class="ToolbarButton"
      :class="{ 'is-active': currentValue == 'center' }"
      value="mdi:format-align-center"
    />

    <UiIcon
      :title="$t('AlignButtons.AlignRight')"
      @click="currentValue = 'right'"
      class="ToolbarButton"
      :class="{ 'is-active': currentValue == 'right' }"
      value="mdi:format-align-right"
    />

    <UiIcon
      :title="$t('AlignButtons.Justify')"
      @click="currentValue = 'justify'"
      class="ToolbarButton"
      :class="{ 'is-active': currentValue == 'justify' }"
      value="mdi:format-align-justify"
    />
  </div>
</template>

<script>
import useI18n from '@/modules/i18n/mixins/useI18n.js';
import { UiIcon } from '@/modules/ui/components';

export default {
  components: {
    UiIcon,
  },
  mixins: [useI18n],

  props: {
    editor: {
      type: Object,
      required: true,
    },
  },

  computed: {
    currentValue: {
      get() {
        if (this.editor.isActive({ textAlign: 'left' })) {
          return 'left';
        }
        if (this.editor.isActive({ textAlign: 'center' })) {
          return 'center';
        }
        if (this.editor.isActive({ textAlign: 'right' })) {
          return 'right';
        }
        if (this.editor.isActive({ textAlign: 'justify' })) {
          return 'justify';
        }
        return null;
      },

      set(newValue) {
        this.editor.chain().focus().setTextAlign(newValue).run();
      },
    },
  },

  i18n: {
    en: {
      'AlignButtons.AlignLeft': 'Align left',
      'AlignButtons.AlignCenter': 'Align center',
      'AlignButtons.AlignRight': 'Align right',
      'AlignButtons.Justify': 'Justify',
    },
    es: {
      'AlignButtons.AlignLeft': 'Alinear a la izquierda',
      'AlignButtons.AlignCenter': 'Alinear al centro',
      'AlignButtons.AlignRight': 'Alinear a la derecha',
      'AlignButtons.Justify': 'Justificar',
    },
    de: {
      'AlignButtons.AlignLeft': 'Links ausrichten',
      'AlignButtons.AlignCenter': 'Zentriert ausrichten',
      'AlignButtons.AlignRight': 'Rechtsbündig',
      'AlignButtons.Justify': 'Ausrichten',
    },
  },
};
</script>

<style lang="scss">
</style>